<template>
  <form>
    <b-alert variant="danger" show v-if="error">
      {{ error }}
    </b-alert>
    <string-form-field
      :label="$t('resetPassword.fields.email')"
      required
      v-model="email">
      <b-input-group-text slot="prepend">
        <i class="fa fa-fw fa-at"></i>
      </b-input-group-text>
    </string-form-field>
    <b-button
      variant="primary"
      block
      class="mt-4"
      @click.prevent="resetPassword">
      {{ $t('resetPassword.actions.resetPassword') }}
    </b-button>
  </form>
</template>
<script>
import { LoggedUserService } from "vue-template";

export default {
  data() {
    return {
      email: null,
      error: null,
    };
  },

  methods: {
    async resetPassword() {
      try {
        this.error = null;
        const result = await LoggedUserService.resetPassword({
          email: this.email
        });
        console.log(result);
        this.$emit('password-reset', result);
      } catch (e) {
        console.error(e);
        this.error = this.$error2text(e.data);
      }
    }
  }
};
</script>
